import "reflect-metadata";


export const staticObjectTypes: Function[] = [];

export function ObjectType() {
  return (ctor: Function) => {
    staticObjectTypes.push(ctor);

  };
}

export interface FieldProps {
  q?: string[];
  key?: boolean;
  sub?: () => Function;
}

class ObjectMeta {
  columns = new Map<string, FieldProps>();
  keys: string[] = [];
  //  label: string;
  //  relations: Map<string, RelationProps> = new Map();
}

const metaKey = Symbol("objmeta");



// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function meta(o: any): ObjectMeta {
  let objectMeta: ObjectMeta = Reflect.getMetadata(metaKey, o);
  if (objectMeta) {
    return objectMeta;
  }
  objectMeta = new ObjectMeta();
  Reflect.defineMetadata(metaKey, objectMeta, o);

  return objectMeta;
}



export function Field(props: FieldProps = {}) {
  return (target: object, propertyKey: string) => {

    const m = meta(target);
    m.columns.set(propertyKey, props);
    if (props && props.key) {
      if (!m.keys) {
        m.keys = [propertyKey];
      }
      else {
        m.keys.push(propertyKey);
      }
    }
    Reflect.defineMetadata(metaKey, m, target);
  };
}

/**
 * Find properties of target that are defined as with Field decorator.
 * If query name provided, only those Fields that are part of the named
 * query are returned.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getColumns(target: any, query?: string): string[] {
  const rv = [];
  const meta = Reflect.getMetadata(metaKey, target.prototype) as ObjectMeta;

  let keyCol: string | undefined;

  if (!query) {
    for (const entry of meta.columns.entries()) {
      if (entry[1].key) {
        keyCol = entry[0];
      }
      if (entry[1].sub) {
        const sub = entry[1].sub();
        const subcols = getColumns(sub, query);
        rv.push(`${entry[0]} { ${subcols} }`);
      }
      else {
        rv.push(entry[0]);
      }
    }
  }
  else {
    // a specific query
    for (const entry of meta.columns.entries()) {
      if (entry[1].key) {
        keyCol = entry[0];
      }
      if ((entry[1]?.q || []).includes(query)) {
        rv.push(entry[0]);  
      }
    }
  }
  if (rv.length === 0) {
    if (keyCol) {
      rv.push(keyCol);
    }
    else {
      rv.push(Array.from(meta.columns.keys())[0]);
    }
  }
  return rv;
}

